import { createDecorator, VueDecorator } from "vue-class-component";
import Vue, { ComponentOptions, PropOptions } from "vue";

export function HoldModel(
  propOptions: PropOptions = {},
  event = "input",
  prop = "value"
): VueDecorator {
  return createDecorator(
    (componentOptions: ComponentOptions<Vue>, k: string) => {
      componentOptions.model = { prop, event };

      ((componentOptions.props || (componentOptions.props = {})) as any)[
        prop
      ] = propOptions;
      (componentOptions.computed || (componentOptions.computed = {}))[k] = {
        get() {
          return (this as any)[prop];
        },
        set(val: any) {
          return (this as any).$emit(event, val);
        },
      };
    }
  );
}
